import { MARKETING_API } from '@/constants/API';
import { request } from '@umijs/max';

// 我的助手列表
export async function getAssistantList(params: any) {
  return request(`${MARKETING_API}/product/assistant/getAssistantList`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}
